let showPermissionError: ((message: string) => void) | null = null;

export const setPermissionErrorHandler = (
  handler: (message: string) => void,
) => {
  showPermissionError = handler;
};

export const triggerPermissionError = (message: string) => {
  if (showPermissionError) {
    showPermissionError(message);
  }
};
